<template>
  <div class="inline-block bg-gray-200 rounded-full dark:bg-gray-700" :style="style" />
</template>

<script setup lang="ts">
interface Props {
  width?: string;
  height?: string;
}

const props = withDefaults(defineProps<Props>(), {
  width: '10rem',
  height: '1rem',
});

const style = computed(() => {
  return {
    width: props.width,
    height: props.height,
  };
});
</script>

<style scoped>

</style>